export default "__VITE_ASSET__hQ29JSX5__"